import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4dfc3653"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "OTipoAtividadeInformacoes",
  "data-testid": "OTipoAtividadeInformacoes"
}
const _hoisted_2 = { class: "OTipoAtividadeInformacoes__DuracaoPadrao" }

import { MInput } from "@/components/Gerais"
  import { OHoras } from "@/components/AtributoComValor"
  import useVuelidate from "@vuelidate/core"
  import { helpers, required } from "@vuelidate/validators"
  import { computed } from "vue"
  import { useI18n } from "vue-i18n"

  interface Props {
    nome: string
    codigo: string
    duracao: number
    escopoValidacao?: string
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OTipoAtividadeId',
  props: {
    nome: null,
    codigo: null,
    duracao: null,
    escopoValidacao: null
  },
  emits: ["update:nome", "update:codigo", "update:duracao"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "update:nome", nome: string)
    (event: "update:codigo", codigo: string)
    (event: "update:duracao", duracao: number)
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    nome: string
    codigo: string
    duracao: number
    escopoValidacao?: string
  }

  

  const { t } = useI18n()

  

  const emitirNome = computed({
    get() {
      return props.nome
    },
    set(nome: string) {
      emitir("update:nome", nome)
    },
  })
  const emitirCodigo = computed({
    get() {
      return props.codigo
    },
    set(codigo: string) {
      emitir("update:codigo", codigo)
    },
  })
  const emitirDuracao = computed({
    get() {
      return props.duracao
    },
    set(duracao: number) {
      emitir("update:duracao", duracao)
    },
  })
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const regras = {
    nome: {
      obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
    },
    codigo: {
      obrigatorio: helpers.withMessage(t("campoObrigatorio"), required),
    },
  }

  const v$ = useVuelidate(
    regras,
    {
      nome: emitirNome,
      codigo: emitirCodigo
    },
    { $scope: props.escopoValidacao }
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(MInput), {
      modelValue: _unref(v$).nome.$model,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).nome.$model) = $event)),
      class: _normalizeClass(["OTipoAtividadeInformacoes__Nome", { 'p-invalid': _unref(v$).nome.$invalid }]),
      label: _unref(t)('nome'),
      "mensagem-de-erro": _unref(v$).nome.$errors[0]?.$message,
      nome: "nome",
      obrigatorio: "",
      "tipo-entrada": "text"
    }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
    _createVNode(_unref(MInput), {
      modelValue: _unref(v$).codigo.$model,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).codigo.$model) = $event)),
      class: _normalizeClass(["OTipoAtividadeInformacoes__Codigo", { 'p-invalid': _unref(v$).codigo.$invalid }]),
      label: _unref(t)('codigo'),
      "mensagem-de-erro": _unref(v$).codigo.$errors[0]?.$message,
      nome: "codigo",
      obrigatorio: "",
      "tipo-entrada": "text"
    }, null, 8, ["modelValue", "class", "label", "mensagem-de-erro"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(t)('duracao')), 1),
      _createVNode(_unref(OHoras), {
        modelValue: _unref(emitirDuracao),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(emitirDuracao) ? (emitirDuracao).value = $event : null))
      }, null, 8, ["modelValue"])
    ])
  ]))
}
}

})